<h1 mat-dialog-title i18n>
	Associate to app keys <small class="align-top">- {{dialogData.terms.displayName}}</small>
</h1>
<form [formGroup]="formInputs" (ngSubmit)="onFormSubmit()">
	<div mat-dialog-content class="main-content">
		<div class="row align-items-center">
			<mat-form-field appearance="standard" class="col-12 col-md-auto" *ngIf="clusters.length > 1">
				<mat-label i18n>Cluster</mat-label>
				<mat-select formControlName="cluster">
					<mat-option value="" i18n>All</mat-option>
					<mat-option
						*ngFor="let cluster of clusters"
						[value]="cluster.id"
					>{{cluster.name}}</mat-option>
				</mat-select>
			</mat-form-field>
			<mat-form-field appearance="standard" class="col-12 col-md-auto" *ngIf="providers.length > 1">
				<mat-label i18n>Provider</mat-label>
				<mat-select formControlName="provider">
					<mat-select-trigger class="text-capitalize" i18n>{{formInputs.controls.provider.value ? formInputs.controls.provider.value : 'All'}}</mat-select-trigger>
					<mat-option value="" i18n>All</mat-option>
					<mat-option
						class="text-capitalize"
						*ngFor="let provider of providers"
						[value]="provider"
					>{{provider}}</mat-option>
				</mat-select>
			</mat-form-field>

			<mat-form-field appearance="standard" class="col-12 col-md-auto legal-associate__select" floatLabel="always">
				<mat-label i18n>App Keys</mat-label>
				<mat-select #appKeySelect formControlName="appKeys" placeholder="{{ selectedAppKeys.length }} selected" panelClass="mat-select-multi-line">
					<mat-select-trigger i18n>{{selectedAppKeys.length}} Selected</mat-select-trigger>

					<div class="legal-associate__select-all" mat-menu-item (click)="selectAll()" *ngIf="appKeys.length > 0">Select All</div>
					<mat-divider></mat-divider>

					<mat-option *ngIf="appKeys.length === 0" i18n>All selected</mat-option>
					<mat-option
						*ngFor="let appKey of appKeys"
						[value]="appKey"
					>
						{{appKey.name}}
						<div>
							<span
								class="badge badge-pill badge-secondary deploy-badge mt-1 mr-2 py-1 px-2 text-capitalize {{ appKey.provider != 'local' ? 'badge-' + appKey.provider : '' }}"
							>{{appKey.provider}}</span>
							<span
								class="badge badge-pill badge-secondary deploy-badge mt-1 mr-2 py-1 px-2"
							>{{ appKey?.clusterName ? appKey?.clusterName : appKey?.clusterId }}</span>
							<span
								class="badge badge-pill badge-info deploy-badge mt-1 mr-2 py-1 px-2"
							>{{ appKey.clientId }}</span>
						</div>
					</mat-option>
				</mat-select>
			</mat-form-field>

			<div class="col-12 col-md-auto">
				<button
					type="button"
					(click)="removeAllAppKeys()"
					title="Deselect All"
					i18n-title
					[disabled]="selectedAppKeys.length === 0"
					mat-flat-button
					color="warn"
					i18n
					class="w-100"
				>Deselect All</button>
			</div>
		</div>
		<div class="row mb-4" [ngClass]="{'hide-element': selectedAppKeys.length === 0 }">
			<div class="col">
				<div class="table-responsive">
					<table
						mat-table
						matSort
						[dataSource]="selectedAppKeys"
						class="w-100"
						multiTemplateDataRows
						aria-label="List of app keys to associate"
					>
						<ng-container matColumnDef="name">
							<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n>Name</th>
							<td mat-cell *matCellDef="let row" class="text-nowrap">{{ row.name }}</td>
						</ng-container>

						<ng-container matColumnDef="clientId">
							<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n>Client ID</th>
							<td mat-cell *matCellDef="let row" class="text-nowrap">{{row.clientId}}</td>
						</ng-container>

						<ng-container matColumnDef="provider">
							<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n>Provider</th>
							<td mat-cell *matCellDef="let row" class="text-nowrap text-capitalize">{{row.provider}}</td>
						</ng-container>

						<ng-container matColumnDef="clusterName">
							<th class="no-wrap" scope="col" mat-header-cell *matHeaderCellDef mat-sort-header i18n>Cluster</th>
							<td mat-cell *matCellDef="let row" class="text-nowrap text-capitalize">{{row.clusterName ? row.clusterName : row.clusterId}}</td>
						</ng-container>

						<ng-container matColumnDef="action" [stickyEnd]="true">
							<th scope="col" mat-header-cell *matHeaderCellDef class="text-center"></th>
							<td mat-cell *matCellDef="let row; let i = dataIndex" class="actions text-center no-wrap">
								<button
									mat-icon-button
									type="button"
									(click)="removeAppKey(row)"
									title="Remove"
									i18n-title
									class="text-danger"
								><mat-icon>delete</mat-icon></button>
							</td>
						</ng-container>

						<tr mat-header-row *matHeaderRowDef="tableColumns"></tr>
						<tr
							mat-row
							*matRowDef="let row; columns: tableColumns; let i = dataIndex;"
						></tr>
					</table>
				</div>
			</div>
		</div>
	</div>
	<div mat-dialog-actions class="row justify-content-center px-1 mb-0">
		<div class="col col-md-4 text-center">
			<button class="w-100" mat-flat-button mat-dialog-close i18n type="button">Cancel</button>
		</div>
		<div class="col col-md-4 text-center">
			<button
				class="w-100"
				[disabled]="selectedAppKeys.length === 0"
				type="submit"
				mat-flat-button
				color="primary"
				i18n
			>Save</button>
		</div>
	</div>
</form>
